<script>
    export let activity={};
    import {apiUrl} from '../../../config.svelte';
    import Filter from './Filter.svelte'
    import {Table,Button,Input,CustomInput,Alert} from 'sveltestrap'
    import {onMount} from 'svelte'

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    let calls=undefined
    onMount(()=>{
        loadCalls()
    })

    function loadCalls(filter,search){
        calls=undefined
        fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"load-calls",activity:activity.activity,filter:filter,search:search}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                calls=x.data
            }else{
                calls=[]
            }
        })
        .catch((e)=>{
            calls=[]
        })
    }

    let err;
    let selectedCall;
    let selectedAudio
    function play(audio){
        selectedAudio=audio
        dispatch("play",{audio:audio})
    }

    function playNode(audio){
        selectedAudio=audio
        let src=`/records/ivm/nodes/${activity.activity}/${decodeURI(audio)}`
        dispatch("play",{audio:src})
    }

    let table ;    
    const showCount = 100;
    let currentPosition = 0;
    function scrollTable(more){
        if(more){
            if(currentPosition*showCount<calls.length)
            currentPosition=currentPosition+1;
            
        }else{
            if(currentPosition>0){
                currentPosition=currentPosition-1;
            }
        }
        calls=calls
    }
    let callNodes=[]
    function chooseCall(call){
        callNodes=[]
        fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"load-nodes",callId:call.callId}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                callNodes=x.data
                selectedCall=call
            }
        })
        .catch((e)=>{
        })
    }

    function Search(e){
        let search = e.detail.search
        loadCalls(undefined,search)
    }
     

</script>
<style>
    .table-responsive{height:calc(100% - 25px);overflow-y:scroll;} 
    thead tr:nth-child(1) th{background: white; position: sticky;top: 0;z-index: 10;}
</style>

<Filter bind:activity on:search={(e)=>{Search(e)}}  on:filterChanged={(e)=>{loadCalls(e.detail.filter)}}/>

<div style="height:850px;width:100%">
    <table class="table table-fixed table-responsive " bind:this={table}  >
        <thead style="color:rgb(29, 29, 29)">
            <tr class="bg-info">
                <th scope="col">cardId</th>
                <th scope="col">callId</th>
                <th scope="col">phone</th>
                <th scope="col">callDt</th>
                <th scope="col">status</th>
                <th scope="col">elemName</th>
                <th scope="col">comment</th>
                <th scope="col">audio</th>
                <th scope="col">callLength</th>
                <th scope="col">xtelelink</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            {#if calls}
                <tr><td colspan="10"><Button disabled={currentPosition>0?undefined:true} block outline color="secondary" on:click={()=>{scrollTable(false)}}>Ранее...</Button></td></tr>
                {#each calls as call}
                    {#if call.id > currentPosition*showCount && call.id <= (currentPosition+1) * showCount }
                        <tr style="cursor:pointer;background-color:{selectedCall==call?"rgb(118, 250, 118)":"white"}" >
                            <td>{call.cardId}</td>
                            <td>{call.callId}</td>
                            <td>{call.phone}</td>
                            <td>{call.callDt.substring(0,19)}</td>
                            <td>{call.status}</td>
                            <td>{call.elemName}</td>
                            <td title={call.comment}>{(call.comment&&call.comment.length>15?`${call.comment.substring(0,15)}...`:(call.comment==null || call.comment==undefined?"":call.comment))}</td>
                            <td><button style={(call.audio==selectedAudio?"background:green":"")} on:click={()=>{play(call.audio)} }>play</button></td>
                            <td>{call.callLength}</td>
                            <td>{call.xtelelink}</td>
                            <td><button on:click={()=>{if(selectedCall==call){selectedCall=undefined}else{chooseCall(call)}}}>ноды</button></td>
                        </tr>
                        {#if selectedCall==call}
                            <tr>
                                <td style="font-weight:bold;background:grey"></td>
                                <td style="font-weight:bold">elemName</td>
                                <td style="font-weight:bold">ignoredText</td>
                                <td style="font-weight:bold">rText</td>
                                <td style="font-weight:bold">nextNode</td>
                                <td style="font-weight:bold">nextType</td>
                                <td style="font-weight:bold">audio</td>
                            </tr>
                            {#each callNodes as node}
                                <tr>
                                    <td style="background:green"></td>
                                    <td>{node.nodeName}</td>
                                    <td>{node.ignoredText}</td>
                                    <td>{node.rText}</td>
                                    <td>{node.nextNode}</td>
                                    <td>{node.nextType}</td>
                                    <td>
                                        <button style={(call.audio==selectedAudio?"background:green":"")} on:click={()=>{playNode(node.audio)} }>play</button>
                                    </td>
                                    <td colspan="4"></td>
                                </tr>
                            {/each}
                        {/if}
                    {/if}
                {/each}
                <tr><td colspan="10"><Button disabled={(currentPosition+1)*showCount< calls.length ?undefined:true} block outline color="secondary" on:click={()=>{scrollTable(true)}}>Далее...</Button></td></tr>
            {:else if err!=undefined &&err!='' }
                <tr><td colspan="10"><Alert color="danger">{err}</Alert></td> </tr>
            {:else if err==''}
                <tr></tr>
            {:else}
                <tr><td colspan="10"><img src="/img/spinner.gif" alt="loading"/></td> </tr>
            {/if}
        </tbody>
    </table>
</div>

